import { Box, useTheme } from "@mui/material";
import { FC, useMemo } from "react";
import { ChartLoading, ChartNoData, generalizeData, genericChartOptions, useChartUtilsWithUserTime } from "../databases/metricsChartCommon";
import Chart from 'react-apexcharts'
import { merge } from "lodash";
import { LineChartWithPairsResponseDto } from "@/gen/api/metrics";


const sizeFormatter = (value:number) => { 
  if (value === 0) return '0 MB'
  if (!value) return ''
  const surfix = ' MB'
  const num = value / 1024 / 1024
  return `${Number.isInteger(num) ? num : num.toFixed(1)}${surfix}` 
}

const DiskIOChart: FC<{
  diskLineData?: LineChartWithPairsResponseDto,
  loading?: boolean,
}> = ({
  diskLineData,
  loading,
}) => {
  const theme = useTheme();
  const { pairWithUserTime } = useChartUtilsWithUserTime()

  const finalData = useMemo(() => {
    const inputData: LineChartWithPairsResponseDto = {
      legend: diskLineData?.legend,
      series: diskLineData?.series && diskLineData?.series.map(s => ({
        name: s.name,
        data: s.data && s.data.map(pairWithUserTime)
      }))
    }
    return generalizeData(theme, inputData, ['#388E3C', '#F57C00'])
  }, [theme, diskLineData])

  const genericOptions = useMemo(() => genericChartOptions(theme), [theme])
  
  const chart = useMemo(() => {
  
    const erase = {
      options: {
        markers: null,
      },
    }
    const patch = {
      options: {
        markers: { size: 0 },
      },
    }
    return merge({}, genericOptions, {
      options: {
        chart: { animations: { enabled: false } },
        colors: finalData.series.map((item) => item.color),
        tooltip: {
          x: { format: 'dd MMM / HH:mm' }
        },
        xaxis: {
          type: 'datetime',
        },
        yaxis: [{
          labels: {
            formatter: sizeFormatter,
          },
        }],
        legend: { show: true },
      },
      series: finalData.series.map(s => ({
        ...s,
        data: s.data
      })),
    }, erase, patch)
  }, [genericOptions, finalData.series, finalData]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <Box>
      <Chart
        height="350"
        type="line"
        {...chart}
      />
      <ChartNoData show={!loading && finalData.series.length === 0} />
      <ChartLoading show={loading} />
    </Box>
  )
}

export default DiskIOChart;
